import React, { useState } from "react";
import AuthHelper from "../../helpers/auth-helper/auth-helper";
import { Link } from "react-router-dom";

import "./signup-page.scss";

const SignupPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [linkSent, setLinkSent] = useState(false);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSendSignupLink = async () => {
    setLoading(true);
    setError("");

    // Validate email format
    if (!email) {
      setError("Email is required.");
      setLoading(false);
      return;
    }

    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      setLoading(false);
      return;
    }

    try {
      // Check if email already exists
      const emailExists = await AuthHelper.checkEmailExists(email);

      if (emailExists) {
        setError("This email is already registered. Please log in instead.");
        setLoading(false);
        return;
      }

      // Send signup link via Firebase
      await AuthHelper.sendSignupLink({ email });

      // Show success message
      setLinkSent(true);
    } catch (err) {
      setError(err.message || "Failed to send signup link. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleResendLink = async () => {
    setLinkSent(false);
    handleSendSignupLink();
  };

  if (linkSent) {
    return (
      <div className="container-fluid signup-bg">
        <div className="row vh-100 d-flex justify-content-center">
          <div className="col-12 align-self-center">
            <div className="card-body">
              <div className="row">
                <div className="col-lg-4 mx-auto">
                  <div className="card">
                    <div className="card-body p-0 auth-header-box">
                      <div className="text-center p-3">
                        <a href="index.html" className="logo logo-admin">
                          <img
                            src="assets/images/logo_new.png"
                            height={50}
                            alt="logo"
                            className="auth-logo"
                          />
                        </a>
                        <h4 className="mt-3 mb-1 fw-semibold font-18">
                          Check Your Email
                        </h4>
                      </div>
                    </div>
                    <div className="card-body pt-0">
                      <div className="text-center my-4">
                        <div className="mb-4">
                          <i className="fas fa-envelope-open-text text-primary" style={{ fontSize: '3rem' }}></i>
                        </div>
                        <p className="text-muted mb-2">
                          We've sent a signup link to:
                        </p>
                        <p className="fw-semibold mb-4">{email}</p>
                        <p className="text-muted mb-4">
                          Click the link in your email to continue with signup.
                        </p>
                        <button
                          className="btn btn-outline-primary"
                          onClick={handleResendLink}
                          disabled={loading}
                        >
                          {loading ? "Sending..." : "Resend Link"}
                        </button>
                        <div className="text-center mt-4">
                          <small>
                            Already have an account? <Link to="/login">Log in</Link>
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid signup-bg">
      <div className="row vh-100 d-flex justify-content-center">
        <div className="col-12 align-self-center">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-4 mx-auto">
                <div className="card">
                  <div className="card-body p-0 auth-header-box">
                    <div className="text-center p-3">
                      <a href="index.html" className="logo logo-admin">
                        <img
                          src="assets/images/logo_new.png"
                          height={50}
                          alt="logo"
                          className="auth-logo"
                        />
                      </a>
                      <h4 className="mt-3 mb-1 fw-semibold font-18">
                        Create Your Account
                      </h4>
                      <p className="text-muted mb-0">
                        Get started with Jely today
                      </p>
                    </div>
                  </div>
                  <div className="card-body pt-0">
                    <form
                      className="my-4"
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <div className="form-group mb-3">
                        <label className="form-label" htmlFor="email">
                          Email Address
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          placeholder="Enter your email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          disabled={loading}
                        />
                        <small className="text-muted">
                          We'll send you a link to complete your signup
                        </small>
                      </div>

                      <div className="form-group mb-0">
                        <div className="d-grid">
                          <button
                            className="bouncy-button small"
                            type="button"
                            onClick={handleSendSignupLink}
                            disabled={loading}
                          >
                            {loading ? "Sending..." : "Continue"}{" "}
                            <i className="fas fa-arrow-right ms-1" />
                          </button>
                        </div>
                      </div>

                      {error && (
                        <div className="errorMessage mt-3">
                          <p className="text-danger mb-0">{error}</p>
                        </div>
                      )}

                      <div className="text-center mt-4">
                        <small>
                          Already have an account? <Link to="/login">Log in</Link>
                        </small>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupPage;
